// 接口服务器地址
const FORMAL_SERVER = 'https://api.aircourses.com'; // 正式服
const PRE_SERVER = 'http://47.111.78.238:8087'; // 预发布

const TEST_SERVER = '192.168.10.209'; // 测试服
const DEV_SERVER = '192.168.10.202'; // 开发服
const LOCAL_SERVER = '192.168.10.202'; // 本地服

// 前端项目端口
const WEB_PORT1 = '8103';
const WEB_PORT2 = '18103';
// 后端接口端口
const API_PORT1 = '18087';
const API_PORT2 = '28087';
// URL
const hostName = window.location.hostname; // 域名
const port = window.location.port; // 端口号
const protocol = window.location.protocol; // 协议

let apiUrl;

if (hostName === 'client.aircourses.com') {
    apiUrl = FORMAL_SERVER;
} 
else if (hostName === '47.111.78.238') {
    apiUrl = PRE_SERVER;
} 
else if (hostName === TEST_SERVER || hostName === DEV_SERVER) {
    switch (port) {
        case WEB_PORT1:
            apiUrl = `${protocol}//${hostName}:${API_PORT1}`;
            break;
        case WEB_PORT2:
            apiUrl = `${protocol}//${hostName}:${API_PORT2}`;
            break;
        default:
            apiUrl = `${protocol}//${hostName}:${API_PORT1}`;
            break;
    }
} else {
	apiUrl = `${protocol}//${LOCAL_SERVER}:${API_PORT1}`;
}

export default apiUrl;


// WEBPACK FOOTER //
// ./src/api/serveConfig.js